// frontend/src/admin/blockforms/NumericalForm.js
import React, { useState, useEffect } from 'react';
import { buildBlockSave } from './blockSaveTarget';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const emptyContent = () => ({
    heading: '',
    steps: [{ content: '', explanation: '' }]
});

const NumericalForm = ({ level, entityId, section, editingBlock, nextOrderIndex, onSaved, onCancel }) => {
    const existing = editingBlock?.content_data || {};

    const [en, setEn] = useState(existing.en || emptyContent());
    const [hi, setHi] = useState(existing.hi || null);
    const [addHindi, setAddHindi] = useState(!!existing.hi);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [en, hi]);

    const updateField = (setter, data, field, value) => setter({ ...data, [field]: value });

    const updateStep = (setter, data, index, field, value) => {
        const steps = [...data.steps];
        steps[index] = { ...steps[index], [field]: value };
        setter({ ...data, steps });
    };
    const addStep = (setter, data) => setter({ ...data, steps: [...data.steps, { content: '', explanation: '' }] });
    const removeStep = (setter, data, index) => setter({ ...data, steps: data.steps.filter((_, i) => i !== index) });

    const renderEditor = (data, setter, label) => (
        <div className="ace-table-editor">
            <label>{label} — Heading (optional)</label>
            <input type="text" value={data.heading} onChange={(e) => updateField(setter, data, 'heading', e.target.value)} placeholder="e.g. How to find acceleration" />

            <label>Steps</label>
            {data.steps.map((s, i) => (
                <div key={i} className="ace-num-step-block">
                    <div className="ace-table-row">
                        <span className="ace-step-num">Step {i + 1}</span>
                        <textarea
                            rows={2}
                            placeholder="Step content"
                            value={s.content}
                            onChange={(e) => updateStep(setter, data, i, 'content', e.target.value)}
                        />
                        <button type="button" onClick={() => removeStep(setter, data, i)}>✕</button>
                    </div>
                    <div className="ace-step-explanation-row">
                        <textarea
                            rows={2}
                            placeholder="Explanation (optional, shown indented)"
                            value={s.explanation}
                            onChange={(e) => updateStep(setter, data, i, 'explanation', e.target.value)}
                        />
                    </div>
                </div>
            ))}
            <button type="button" onClick={() => addStep(setter, data)}>+ Add Step</button>
        </div>
    );

    const handleSave = async () => {
        if (!en.steps.some(s => s.content.trim())) {
            setError('Please enter at least one step');
            return;
        }
        setError(null);
        setSaving(true);

        const content_data = { en };
        if (addHindi && hi) {
            content_data.hi = hi;
        }

        const { url, method, payload } = buildBlockSave({
            level, entityId, section, editingBlock,
            blockType: 'steps',
            contentData: content_data,
            orderIndex: nextOrderIndex,
        });

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.detail || 'Save failed');
            }
            onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ace-form">
            <h4>{editingBlock ? 'Edit' : 'Add'} Steps Block</h4>
            {error && <div className="ace-error">{error}</div>}

            {renderEditor(en, setEn, 'English')}

            {!addHindi && (
                <button type="button" onClick={() => { setAddHindi(true); setHi(emptyContent()); }}>
                    + Add Hindi Version
                </button>
            )}

            {addHindi && hi && renderEditor(hi, setHi, 'Hindi')}

            <div className="ace-form-actions">
                <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                <button onClick={onCancel} className="ace-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default NumericalForm;